(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wr-first20-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('WrFirst20Popup');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const storageKey = 'wr-first20-popup-until';
    const day = 24 * 60 * 60 * 1000;
    const success = dialog.dataset.success === 'true';
    const designMode = dialog.dataset.designMode === 'true';

    const readUntil = () => {
      try {
        return Number(window.localStorage.getItem(storageKey) || 0);
      } catch {
        return 0;
      }
    };

    const remember = (days) => {
      try {
        window.localStorage.setItem(storageKey, String(Date.now() + days * day));
      } catch {
        return;
      }
    };

    const closeDialog = () => {
      if (dialog.open) dialog.close();
    };

    dialog.querySelectorAll('[data-wr-first20-close]').forEach((button) => {
      button.addEventListener('click', () => {
        remember(success ? 90 : 7);
        closeDialog();
      });
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        remember(7);
        closeDialog();
      }
    });

    dialog.addEventListener('cancel', () => {
      remember(7);
    });

    if (success) {
      remember(90);
      dialog.showModal();
      return;
    }

    if (designMode || readUntil() > Date.now()) return;

    window.setTimeout(() => {
      if (!dialog.open) dialog.showModal();
    }, 8000);
  })();
  } catch(e) { console.error(e); }
})();

})();
